import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  Button,
  Modal,
  Form,
} from 'react-bootstrap';
import { Icon } from '@iconify/react';
import DataTable from "react-data-table-component";
import { Link } from 'react-router-dom';
import { getCharactersList, updateCharacterStatus, destroyCharacter } from '../../api/taleService';

export default function Characters() {
  const [searchText, setSearchText] = useState('');
  const [characters, setCharacters] = useState([]);
  const [characterToDelete, setCharacterToDelete] = useState(null);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const handleClose = () => setShow(false);

  useEffect(() => {
    fetchCharacters();
  }, []);

  const fetchCharacters = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await getCharactersList();
      if (response && response.data) {
        setCharacters(response.data);
      }
    } catch (error) {
      setError("Error fetching characters");
      console.error("Error fetching characters", error);
    } finally {
      setLoading(false);
    }
  };

  const handleToggleStatus = async (id, currentStatus) => {
    const newStatus = currentStatus === "Active" ? "Inactive" : "Active";
    try {
      setError(null);
      const response = await updateCharacterStatus({ 
        characterId: id, 
        status: newStatus 
      });
      
      if (response) {
        setCharacters(prevCharacters =>
          prevCharacters.map(character =>
            character._id === id ? { ...character, status: newStatus } : character
          )
        );
      }
    } catch (error) {
      setError("Failed to update status");
      console.error("Error updating character status", error);
    }
  };

  const handleDeleteCharacter = async () => {
    if (!characterToDelete) return;

    try {
      setError(null);
      const response = await destroyCharacter({ characterId: characterToDelete });
      if (response) {
        setCharacters(prevCharacters => 
          prevCharacters.filter(character => character._id !== characterToDelete)
        );
        setShow(false);
        setCharacterToDelete(null);
      }
    } catch (error) {
      setError("Failed to delete character");
      console.error("Error deleting character", error);
    }
  };

  const handleShowDeleteModal = (id) => {
    setCharacterToDelete(id);
    setShow(true);
  };

  const columns = [
    {
      name: 'ID',
      width: '160px',
      selector: row => row._id,
      sortable: true,
      cell: (row) => row._id     
    },
    {
      name: 'Name',
      width: '190px',
      selector: row => row.character_name,
      sortable: true,
      cell: (row) => row.character_name
    },
    {
      name: 'Username',
      width: '180px',
      selector: row => row.userId.username,
      sortable: true,
      cell: (row) => row.userId.username
    },
    {
      name: 'Date Created',
      width: '180px',
      selector: row => new Date(row.createdAt).toLocaleDateString(),
      sortable: true,
      cell: (row) => new Date(row.createdAt).toLocaleDateString(),
    },
    {
      name: 'Status',
      width: '150px',
      selector: row => row.Status,
      sortable: true,
      cell: (row) => (
        <Form.Check
          type="switch"
          id={`status-switch-${row._id}`}
          checked={row.status === 'Active'}
          onChange={() => handleToggleStatus(row._id, row.status)}
          className="status-switch"
        />
      )
    },
    {
      name: 'Actions',
      width: '150px',
      cell: row => (
        <>
          <Link className="btnview" to={`/admin/character-detail/${row._id}`}>
            <Icon icon="tabler:eye"></Icon>
          </Link>
          <Link className="btndelete" onClick={() => handleShowDeleteModal(row._id)}>
            <Icon icon="tabler:trash"></Icon>
          </Link>
        </>
      ),
    },
  ];

  const filteredData = characters.filter(
    item =>
      JSON.stringify(item)
        .toLowerCase()
        .indexOf(searchText.toLowerCase()) !== -1
  );

  return (
    <React.Fragment>
      <Row>
        <Col lg={12}>
          <Card>
            <Card.Header className="py-4">
              <h5>Characters</h5>
            </Card.Header>
            <Card.Body>
              <div className="text-end mb-3">
                <input
                  type="text"
                  placeholder="Search..."
                  className="searchfield"
                  value={searchText}
                  onChange={e => setSearchText(e.target.value)}
                />
              </div>
              {error && <div className="alert alert-danger">{error}</div>}
              <DataTable
                columns={columns}
                data={filteredData}
                pagination
                responsive
                progressPending={loading}
                className="custom-table"
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Modal className="modal_Delete" show={show} onHide={handleClose} centered>
        <Modal.Body>
          <div className="modaldelete_div">
            <Icon className="delete_icon" icon="gg:close-o"></Icon>
            <h3>Are You Sure ?</h3>
            <p>You will not be able to recover the deleted record!</p>
          </div>
          <Button onClick={handleClose} className="btn btn-primary-outline px-4 me-3">
            Cancel
          </Button>
          <Button className="btn btn-primary px-4 min_width110" onClick={handleDeleteCharacter}>
            Ok
          </Button>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}
